import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Setup window.getPublicUrl for image paths
const publicUrl = process.env.PUBLIC_URL || "";

window.getPublicUrl = (path) =>
  publicUrl ? `${publicUrl}/${path}` : path;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
